/**
 * Generic utilities for miscellaneous functions that are used in more than one components.
 * This could be a good place to house some of the Vue mixins which are somewhat inflexible in usage.
 */

/**
 * Replaces multiple whitespaces, including tabs and newlines, with a single whitespace.
 * @param str
 * @returns {string|*}
 */
export function stripExtraSpaces(str) {
  if (!str) {
    return '';
  }
  return str.trim().replace(/\s\s+/g, ' ');
}